import { render, staticRenderFns } from "./BoundedContextHexagonal.vue?vue&type=template&id=5bb17882&scoped=true&"
import script from "./BoundedContextHexagonal.vue?vue&type=script&lang=js&"
export * from "./BoundedContextHexagonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb17882",
  null
  
)

export default component.exports